import ProfilePicture from "@/components/common/profile-picture";
import VerifiedBadgeCheck from "@/components/common/verified-badge-check";
import { cn, formatImageUrl } from "@/lib/utils";
import Link from "next/link";

type CarouselUserCardProps = {
	className?: string;
	name: string;
	image: string | null;
	isVerified: boolean;
	isAmbassador: boolean;
	isFounder: boolean;
	jobTitle: string | null;
	howDoYouIdentifyYourself: string | null;
	company: string | null;
	username: string;
};

const LeadersCarouselCard = ({
	className,
	name,
	image,
	isVerified,
	isAmbassador,
	isFounder,
	jobTitle,
	howDoYouIdentifyYourself,
	company,
	username,
}: CarouselUserCardProps) => {
	return (
		<Link
			href={`/${username}`}
			className={cn("flex gap-4 whitespace-nowrap rounded-xl bg-white p-6 pr-32", className)}
		>
			<ProfilePicture
				profilePictureUrl={image ? formatImageUrl(image) : null}
				isVerified={isVerified}
				isFounder={isFounder}
				isAmbassador={isAmbassador}
				className={{
					container: "h-12 w-12 rounded-full p-1",
					image: "rounded-full",
					badgeImage: "-bottom-4 h-10 w-10",
				}}
			/>

			<div className="flex flex-col justify-center gap-2">
				<div className="flex items-center gap-1">
					<span className="font-semibold">{name}</span>

					{isFounder && isVerified && <VerifiedBadgeCheck iconClassName="w-4 h-4" />}
				</div>

				<div className="flex items-center gap-1 text-sm font-medium text-gray-600">
					{jobTitle ? jobTitle : howDoYouIdentifyYourself ? howDoYouIdentifyYourself : "-"} |{" "}
					{company || "-"}
				</div>
			</div>
		</Link>
	);
};

export default LeadersCarouselCard;
